"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightContainer = exports.Icon = exports.HeaderTitle = exports.HeaderDescription = exports.Header = exports.Container = exports.CloseButton = exports.ActionButton = void 0;

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _Button = _interopRequireDefault(require("../Button"));

var _Text = require("../Text");

var Container = (0, _styledComponents.default)(_Box.default).attrs({
  paddingType: 'square',
  paddingSize: 'xs',
  radius: 'xs'
}).withConfig({
  componentId: "sc-1turwtw-0"
})(["width:100%;align-items:center;line-height:1;", ""], function (_ref) {
  var bannerColors = _ref.bannerColors,
      show = _ref.show;
  return "\n    background: ".concat(_tokens.colors[bannerColors.backgroundColor.color + bannerColors.backgroundColor.scale], ";\n    border: ").concat(_tokens.borderWidth.xs, "px solid ").concat(_tokens.colors[bannerColors.borderColor.color + bannerColors.borderColor.scale], ";\n    display: ").concat(show ? 'flex' : 'none', ";\n  ");
});
exports.Container = Container;

var Icon = _styledComponents.default.i.withConfig({
  componentId: "sc-1turwtw-1"
})(["display:flex;flex-shrink:0;margin-right:", "px;padding-top:", "px;padding-right:", "px;padding-bottom:", "px;padding-left:", "px;border-radius:", ";svg{height:16px;width:16px;fill:", ";}", ""], _tokens.spacing.horizontal.xs, _elements.boxPadding.square.xxs.top, _elements.boxPadding.square.xxs.right, _elements.boxPadding.square.xxs.bottom, _elements.boxPadding.square.xxs.left, _tokens.borderRadius.pill, _tokens.colors.neutral800, function (_ref2) {
  var bannerColors = _ref2.bannerColors;
  return "\n    background: ".concat(_tokens.colors[bannerColors.iconBackgroundColor.color + bannerColors.iconBackgroundColor.scale], ";\n  ");
});

exports.Icon = Icon;

var Header = _styledComponents.default.div.withConfig({
  componentId: "sc-1turwtw-2"
})([""]);

exports.Header = Header;
var HeaderTitle = (0, _styledComponents.default)(_Text.Title).attrs({
  size: 'body02'
}).withConfig({
  componentId: "sc-1turwtw-3"
})([""]);
exports.HeaderTitle = HeaderTitle;

var HeaderDescription = _styledComponents.default.div.withConfig({
  componentId: "sc-1turwtw-4"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme;
  return "\n    font-family: ".concat(theme.fonts.default, ", sans-serif;\n    font-size: ").concat(theme.typography.body02.desktop.fontSize, "px;\n\n    a {\n      color: ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n    }\n  ");
});

exports.HeaderDescription = HeaderDescription;

var CloseButton = _styledComponents.default.button.withConfig({
  componentId: "sc-1turwtw-5"
})(["border:0;padding:0;height:32px;width:32px;background:transparent;svg{height:13px;width:13px;fill:", ";}"], _tokens.colors.neutral800);

exports.CloseButton = CloseButton;
var ActionButton = (0, _styledComponents.default)(_Button.default).attrs({
  appearance: 'outline',
  size: 'sm'
}).withConfig({
  componentId: "sc-1turwtw-6"
})([""]);
exports.ActionButton = ActionButton;

var RightContainer = _styledComponents.default.div.withConfig({
  componentId: "sc-1turwtw-7"
})(["margin-left:auto;display:flex;", "{margin-left:", ";}"], CloseButton, _tokens.spacing.horizontal.xxxs);

exports.RightContainer = RightContainer;